import styles from '@/pages/Home.module.css';

interface IntegrationDiagramProps {
  /** Small uppercase caption under the stack. Omitted in the hero variant. */
  caption?: string;
}

/**
 * The "typical integration shape" illustration: storefront over an integration
 * layer, feeding ERP and fulfilment.
 *
 * The box-drawing connectors are `aria-hidden`; a screen reader announces the
 * five labelled nodes and skips the pipe characters between them.
 */
export function IntegrationDiagram({ caption }: IntegrationDiagramProps) {
  return (
    <div className={styles.diagram}>
      <div className={styles.diagramStack}>
        <div className={styles.diagramNode}>
          <span className={styles.diagramNodeName}>Storefront</span>
          <span className={styles.diagramNodeKind}>Platform</span>
        </div>

        <div className={styles.diagramConnector} aria-hidden="true">
          │
        </div>

        <div className={styles.diagramNode}>
          <span className={styles.diagramNodeName}>Integration layer</span>
          <span className={styles.diagramNodeKind}>API</span>
        </div>

        <div className={styles.diagramSplit} aria-hidden="true">
          <span>│</span>
          <span>│</span>
        </div>

        <div className={styles.diagramPair}>
          <div className={styles.diagramLeaf}>ERP</div>
          <div className={styles.diagramLeaf}>Fulfilment</div>
        </div>

        {caption && <p className={styles.diagramCaption}>{caption}</p>}
      </div>
    </div>
  );
}
